/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import * as Yup from 'yup';
import { useState } from 'react';
import { Button, Dialog, DialogTitle, DialogContent, IconButton, Grid, Card, Stack, Box } from '@material-ui/core';
import { Icon } from '@iconify/react';
import { useTheme } from '@material-ui/core/styles';
import { Form, FormikProvider, useFormik } from 'formik';
// eslint-disable-next-line import/no-unresolved
import { AddCircleOutlineOutlined } from '@material-ui/icons';
// eslint-disable-next-line import/no-unresolved
import CollectionSingleRuleForm from './CollectionSingleRuleForm';

function CollectionRuleForm({ handleClose, setExclusionRules, parentRuleId, editId }) {
  const [btnSelect, setBtnSelect] = useState(false);
  const editRules = editId?.data;
  const emptyRule = [
    {
      id: parseInt(1 + Math.random() * (1000 - 1), 10),
      column_name: '',
      if_cell_value: '',
      value_or_text: ''
    }
  ];

  const tempRules = editId ? editRules : emptyRule;

  const [rules, setRule] = useState(tempRules);

  const handleAddRule = () => {
    setRule([
      ...rules,
      {
        id: parseInt(1 + Math.random() * (1000 - 1), 10),
        if_cell_value: '',
        value_or_text: '',
        column_name: ''
      }
    ]);
    setBtnSelect(false);
  };

  const handleDeleteRule = (id) => {
    const updatedRules = rules.filter((rule) => rule.id !== id);
    setRule(updatedRules);
    if (rules.length < 2) setBtnSelect(true);
  };

  const NewUserSchema = Yup.object().shape({
    rules: Yup.array(
      Yup.object({
        column_name: Yup.mixed().required('*Required'),
        if_cell_value: Yup.mixed().required('*Required'),
        value_or_text: Yup.mixed().required('*Required')
      })
    )
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      rules
    },
    validationSchema: NewUserSchema,
    onSubmit: async (values, { setSubmitting, resetForm, setErrors }) => {
      try {
        const exclusionRuleData = {
          rules: values.rules
        };

        setSubmitting(false);
        if (editId === 0 || editId) {
          setExclusionRules((prev) => {
            const tempRulesArray = prev;
            tempRulesArray.splice(parentRuleId, 1, exclusionRuleData);
            setExclusionRules([]);
            setExclusionRules(tempRulesArray);
          });
        } else {
          setExclusionRules((prev) => [...prev, exclusionRuleData]);
        }
        handleClose();
        resetForm();
      } catch (error) {
        setSubmitting(false);
        setErrors(error);
      }
    }
  });

  const { errors, values, handleSubmit, isSubmitting } = formik;

  return (
    <FormikProvider value={formik}>
      <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={12}>
            <Card sx={{ p: 3 }}>
              {rules?.map((rule, index) => (
                <CollectionSingleRuleForm
                  data={rule}
                  id={index}
                  key={index}
                  handleDeleteRule={handleDeleteRule}
                  setRule={setRule}
                  rules={rules}
                  errors={errors}
                />
              ))}
              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }} justifyContent="space-between">
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 2, sm: 1 }}>
                  <Button
                    variant="text"
                    startIcon={<AddCircleOutlineOutlined />}
                    onClick={handleAddRule}
                    sx={{ width: '10%', height: '3rem', display: 'flex', justifyContent: 'space-around' }}
                    title="Add"
                  />
                </Stack>
              </Stack>
              <Stack spacing={3}>
                <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
                  <Button sx={{ marginRight: '1rem' }} variant="outlined" onClick={handleClose}>
                    Cancel
                  </Button>
                  <Button
                    sx={{ marginRight: '1rem' }}
                    type="submit"
                    variant="contained"
                    loading={isSubmitting}
                    disabled={btnSelect}
                  >
                    Ok
                  </Button>
                </Box>
              </Stack>
            </Card>
          </Grid>
        </Grid>
      </Form>
    </FormikProvider>
  );
}

export default function CollectionRuleDialog({ dialogTitle, icon, setExclusionRules, editId, parentRuleId }) {
  const [open, setOpen] = useState(false);
  const [fullWidth] = useState(true);
  const [maxWidth] = useState('sm');
  const handleClickOpen = () => {
    setOpen(true);
  };
  const theme = useTheme();

  const handleClose = () => {
    setOpen(false);
  };

  const stylesSheelt = {
    background: '#eeeeee',
    color: theme.palette.primary.main,
    boxShadow: 'none',
    fontSize: '0.78rem',
    fontWeight: '600',
    minWidth: '55px',
    borderRadius: '4px',
    '&:hover': {
      backgroundColor: '#eeeeee'
    }
  };

  return (
    <>
      {icon ? (
        <IconButton title={dialogTitle} size="small" onClick={() => handleClickOpen()}>
          <Icon icon={icon} />
        </IconButton>
      ) : (
        <Button onClick={() => handleClickOpen()} size="small" variant="contained" sx={stylesSheelt}>
          Edit
        </Button>
      )}
      <Dialog open={open} maxWidth={maxWidth} onClose={handleClose} fullWidth={fullWidth}>
        <DialogTitle>{dialogTitle}</DialogTitle>
        <DialogContent style={{ padding: '24px' }}>
          <CollectionRuleForm
            handleClose={handleClose}
            setExclusionRules={setExclusionRules}
            editId={editId}
            parentRuleId={parentRuleId}
          />
        </DialogContent>
      </Dialog>
    </>
  );
}
